/* Product gallery: fade + arrow hint on the vertical thumbnail column when it can scroll. */
(() => {
  const setup = () => {
    const wrap = document.querySelector('.pdp-mode slider-component[id^="GalleryThumbnails"]');
    const list = wrap && wrap.querySelector('.thumbnail-list');
    if (!wrap || !list || wrap.dataset.pdpHint) return;
    wrap.dataset.pdpHint = '1';
    const mk = (dir) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'pdp-thumbs__arrow pdp-thumbs__arrow--' + dir; b.setAttribute('aria-label', document.querySelector('.pdp-mode')?.dataset[dir === 'down' ? 'i18nScrollDown' : 'i18nScrollUp'] || '');
      b.innerHTML = '<svg viewBox="0 0 12 8" width="12" height="8" aria-hidden="true"><path d="' + (dir === 'down' ? 'm1 1.5 5 5 5-5' : 'm1 6.5 5-5 5 5') + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', () => list.scrollBy({ top: (dir === 'down' ? 1 : -1) * list.clientHeight * 0.7, behavior: 'smooth' }));
      wrap.appendChild(b); return b;
    };
    const up = mk('up'), down = mk('down');
    const sync = () => {
      const max = list.scrollHeight - list.clientHeight;
      const can = max > 4;
      up.hidden = !can || list.scrollTop < 4;
      down.hidden = !can || list.scrollTop > max - 4;
    };
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    new ResizeObserver(sync).observe(list);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();

/* "360°" and "View in my room" chips on the product gallery (products with a 3D model only). */
(() => {
  const isTouch = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (window.matchMedia && window.matchMedia('(pointer: coarse)').matches && window.innerWidth < 990);
  const setup = () => {
    const root = document.querySelector('.pdp-mode.pdp-has-model');
    const viewer = root && root.querySelector('slider-component[id^="GalleryViewer"]');
    if (!root || !viewer || viewer.dataset.pdpInit) return;
    viewer.dataset.pdpInit = '1';
    viewer.classList.add('pdp-viewer');
    const sectionId = root.dataset.section;
    const thumbs = () => [...root.querySelectorAll('slider-component[id^="GalleryThumbnails"] .thumbnail')];
    const modelThumb = () => thumbs().find((t) => /3D|model/i.test(t.getAttribute('aria-label') || ''));
    const arUrl = () => { const u = new URL(location.href); u.hash = ''; u.searchParams.set('ar', '1'); return u.toString(); };

    /* overlay layer exactly the size of the image (the slider element is taller than the picture) */
    const layer = document.createElement('div');
    layer.className = 'pdp-layer';
    viewer.appendChild(layer);
    const list = viewer.querySelector('[id^="Slider-Gallery"]');
    const fit = () => { if (list) layer.style.height = list.offsetHeight + 'px'; };
    if (list && window.ResizeObserver) new ResizeObserver(fit).observe(list);
    fit();

    /* chips */
    const chips = document.createElement('div');
    chips.className = 'pdp-chips';
    chips.innerHTML =
      '<button type="button" class="pdp-chip" data-pdp-360><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 4 7.5v9L12 21l8-4.5v-9L12 3z"/><path d="m4 7.5 8 4.5 8-4.5M12 12v9"/></svg><span>' + (root.dataset['i18nGallery-360'] || '') + '</span></button>' +
      '<button type="button" class="pdp-chip" data-pdp-room><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="7" y="2.5" width="10" height="19" rx="2.2"/><path d="M11 18.5h2"/></svg><span>' + (root.dataset.i18nViewInRoom || '') + '</span></button>';
    layer.appendChild(chips);

    /* desktop panel */
    const panel = document.createElement('div');
    panel.className = 'pdp-room'; panel.hidden = true;
    const roomBg = root.dataset.pdpRoomBg || '';
    panel.style.backgroundImage = roomBg ? 'url("' + roomBg + '")' : '';
    panel.innerHTML =
      '<button type="button" class="pdp-room__close" aria-label="' + (root.dataset.i18nClose || '') + '">×</button>' +
      '<div class="pdp-room__card"><div class="pdp-room__qr" data-pdp-qr></div><p class="pdp-room__title">' + (root.dataset.i18nSeeOnWall || '') + '</p><p class="pdp-room__text">' + (root.dataset.i18nSeeOnWallText || '') + '</p><p class="pdp-room__note">' + (root.dataset.i18nSeeOnWallNote || '') + '</p></div>';
    layer.appendChild(panel);
    const renderQR = () => {
      const holder = panel.querySelector('[data-pdp-qr]');
      if (holder.firstChild || typeof window.qrcode !== 'function') return false;
      const qr = window.qrcode(0, 'M'); qr.addData(arUrl()); qr.make();
      holder.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
      return true;
    };
    const showPanel = (on) => {
      panel.hidden = !on; viewer.classList.toggle('pdp-room-open', on);
      chips.querySelector('[data-pdp-room]').setAttribute('aria-pressed', on);
      if (on && !renderQR()) { let n = 0; const t = setInterval(() => { if (renderQR() || ++n > 30) clearInterval(t); }, 200); }
    };

    /* 360 */
    const go360 = () => {
      showPanel(false);
      const t = modelThumb(); if (t) t.click();
      setTimeout(() => { const poster = root.querySelector('.product__media-item.is-active .deferred-media__poster'); if (poster) poster.click(); }, 350);
    };

    /* AR on phones: iOS Quick Look (USDZ) / Android Scene Viewer (GLB) directly, no extra library needed */
    const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isAndroid = () => /Android/i.test(navigator.userAgent);
    const launchAR = () => {
      const glb = root.dataset.pdpGlb, usdz = root.dataset.pdpUsdz, title = root.dataset.pdpTitle || document.title;
      if (isIOS() && usdz) {
        const a = document.createElement('a');
        a.setAttribute('rel', 'ar');
        a.setAttribute('href', usdz + (usdz.includes('#') ? '' : '#allowsContentScaling=0'));
        const img = document.createElement('img'); img.alt = title; img.src = root.dataset.pdpPoster || ''; a.appendChild(img);
        a.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none';
        document.body.appendChild(a); a.click(); setTimeout(() => a.remove(), 1500);
        return;
      }
      if (isAndroid() && glb) {
        const fallback = encodeURIComponent(location.href.split('#')[0]);
        location.href = 'intent://arvr.google.com/scene-viewer/1.0?file=' + encodeURIComponent(glb) + '&mode=ar_preferred&title=' + encodeURIComponent(title) + '&resizable=false' +
          '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=' + fallback + ';end;';
        return;
      }
      go360(); /* AR not available on this device: show the 3D model instead */
    };

    chips.addEventListener('click', (e) => {
      if (e.target.closest('[data-pdp-360]')) go360();
      else if (e.target.closest('[data-pdp-room]')) { if (isTouch()) launchAR(); else showPanel(panel.hidden); }
    });
    panel.querySelector('.pdp-room__close').addEventListener('click', () => showPanel(false));
    root.addEventListener('click', (e) => { if (e.target.closest('.thumbnail') || e.target.closest('.slider-button')) showPanel(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') showPanel(false); });

    /* reflect current slide in the 360 chip */
    const sync = () => {
      const active = root.querySelector('.product__media-item.is-active');
      chips.querySelector('[data-pdp-360]').setAttribute('aria-pressed', !!(active && active.querySelector('product-model')));
    };
    new MutationObserver(sync).observe(viewer, { attributes: true, subtree: true, attributeFilter: ['class'] });
    sync();

    /* opened from the QR code on a phone: offer AR straight away */
    if (isTouch() && new URLSearchParams(location.search).get('ar') === '1') {
      const bar = document.createElement('button');
      bar.type = 'button'; bar.className = 'pdp-arbar';
      bar.innerHTML = '<span>' + (root.dataset.i18nArbarTitle || '') + '</span><small>' + (root.dataset.i18nArbarText || '') + '</small>';
      bar.addEventListener('click', launchAR);
      viewer.parentElement.insertBefore(bar, viewer);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
